module.exports = "/packs/images/svg/twitter~77bfd342bf10708eeed663121868adda.svg";